import React from 'react'
import { Link } from 'react-router-dom'

import { Footer } from '../components/Footer'
import { TopLogo } from '../components/TopLogo'

const Tools: React.FC = () => {
  return (
    <div id="page-root" className="relative flex h-screen flex-col overflow-auto">
      <TopLogo />
      <div className="mx-auto w-full max-w-xl flex-1 px-4 py-60 lg:max-w-6xl">
        <Link
          to="/income-calculator"
          className="block bg-dark-blue font-semibold text-md rounded px-4 py-2 mb-6 text-white text-center"
        >
          Income Calculator
        </Link>
        <Link
          to="/gsa-calculator"
          className="block bg-dark-blue font-semibold text-md rounded px-4 py-2 mb-6 text-white text-center"
        >
          GSA Calculator
        </Link>
      </div>

      <Footer />
    </div>
  )
}

export default Tools
